import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import {
  SavedCardDetails,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperAccountSettingsSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  Page,
  UserNav,
} from '../../components';
import { post } from '../../util/api';

import { TopbarContainer } from '../../containers';
import Button from '../../components/Button/Button';
import css from './StripeSubscriptions.module.css';
const sharetribeSdk = require('sharetribe-flex-sdk');

const sdk = sharetribeSdk.createInstance({
  clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
});

const Cancel = ({ location }) => {
  const [cancelled, setCancelled] = useState(false);
  const title = 'Abonnements';
  const priceId = location.state?.priceId;
  const handleClick = async e => {
    e.preventDefault();

    return post('/api/cancel-subscription', {
      subscriptionId: location.state.subscription.id,
      priceId: location.state.priceId,
      subscription: location.state.subscription,
    })
      .then(resp => {
        return setCancelled(true);
      })
      .catch(e => console.log(e));
  };

  if (cancelled) {
    return <Redirect to={`/subscriptions`} />;
  }

  return (
    <Page title={title}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer
            currentPage="StripeAccountSubscriptionsPage"
            desktopClassName={css.desktopTopbar}
            mobileClassName={css.mobileTopbar}
          />
          <UserNav selectedPageName="StripeAccountSubscriptionsPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperAccountSettingsSideNav currentTab="StripeAccountSubscriptionsPage" />
        <LayoutWrapperMain>
          <div className={css.content}>
            <center>
              <h2>Voulez-vous vraiment annuler cet abonnement ?</h2>
            </center>
            <br />
            <Button onClick={handleClick}>Annuler</Button>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

export default withRouter(Cancel);
